import { useMobilePanel } from '@/app-shell/layout/Navigation/mobile';
import { useSettingsModal } from '@/app-shell/settings/hooks/useSettingsModal';
import { type WorkspaceTopMenuPorts } from '@heidi/workspace';

import { useJoinWorkspaceDialogPorts } from '../team-join/join-workspace-dialog-ports';
import { isRecordingActiveForWorkspaceSwitch } from './workspace-switch-recording-check';

/**
 * The app half of `@heidi/workspace`'s `WorkspaceTopMenu`: the cross-domain
 * recording check, the settings modal opener and the join dialog's own ports.
 */
export const useWorkspaceTopMenuPorts = (): WorkspaceTopMenuPorts => {
  const { open: openSettingsModal } = useSettingsModal();
  const { dismissMobileSidebar } = useMobilePanel();
  const joinDialog = useJoinWorkspaceDialogPorts();

  return {
    isRecordingActive: isRecordingActiveForWorkspaceSwitch,
    onOpenSettings: () => {
      dismissMobileSidebar();
      openSettingsModal(undefined, 'sidebar');
    },
    joinDialog,
  };
};
